import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const getListWarehouse = createAction(ACTION.GET_LIST_WAREHOUSE.REQUEST, (params) => params);
export const fetchSuggestWarehouses = createAction(ACTION.FETCH_WAREHOUSE_SUGGEST.REQUEST, (params) => params);
export const fetchSuggestWarehouseIsPermissions = createAction(ACTION.FETCH_WAREHOUSE_SUGGEST_IS_PERMISSION.REQUEST, (params) => params);
